"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumbersField = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var number_1 = require("../../../../../../shared/core/utils/number");
var copy_1 = require("../../../../copy");
var utils_1 = require("../../../../utils");
var PhoneNumbersField = function (_a) {
    var value = _a.value, errors = _a.errors, handler = _a.handler;
    var _b = (0, core_1.useComponents)(), TelField = _b.TelField, Pii = _b.Pii;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    return value.length ? (react_1.default.createElement(react_1.default.Fragment, null, value.map(function (phoneNumber, index) {
        var id = "phoneNumber-".concat(index);
        var isFirst = index === 0;
        var label = isFirst
            ? copy('profile.phoneLabel')
            : "".concat((0, number_1.formatNumberWithSuffix)(index + 1), " ").concat(copy('profile.phoneNumberLabel'));
        return (react_1.default.createElement(Pii, { as: "div", key: id },
            react_1.default.createElement(TelField, { id: id, label: label, autoComplete: copy('profile.telAutocomplete'), value: phoneNumber, onChange: handler, "data-index": index, error: (0, utils_1.getError)("phoneNumber-".concat(index), errors), "data-testid": "tel-field-".concat(index) })));
    }))) : (react_1.default.createElement(Pii, { as: "div", key: 'phoneNumber-new' },
        react_1.default.createElement(TelField, { id: 'phoneNumber-new', label: copy('profile.phoneLabel'), autoComplete: copy('profile.telAutocomplete'), value: '', onChange: handler, error: (0, utils_1.getError)("phoneNumber-new", errors) })));
};
exports.PhoneNumbersField = PhoneNumbersField;
